import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "coal",
  "use": "coal-usage",
  "viewBox": "0 0 20 17.64",
  "content": "<symbol viewBox=\"0 0 20 17.64\" id=\"coal\"><title>coal</title><path d=\"M18.79,6.33H1.21a1.22,1.22,0,0,0,0,2.44H7.35v.61L2.7,10a8.08,8.08,0,0,0,.86,3.38,3.26,3.26,0,0,1,1.19-.23A3.31,3.31,0,0,1,8,16h4.76a3.28,3.28,0,0,1,4-2.81l.67-4.45h1.38a1.22,1.22,0,0,0,0-2.44Zm-14,7.78a2.35,2.35,0,1,0,2.34,2.35,2.35,2.35,0,0,0-2.34-2.35Zm0,3.38a1,1,0,1,1,1-1,1,1,0,0,1-1,1ZM16,14.11a2.35,2.35,0,1,0,2.33,2.35A2.35,2.35,0,0,0,16,14.11Zm0,3.38a1,1,0,1,1,1-1,1,1,0,0,1-1,1ZM17,5.58s-.7-1.26-1.7-1.44L15.2,2.78l-1-.08s-.63-2.26-2.35-.53l-2,.17,0-.82H8.53s-.61-.76-1,0v2L4.13,3.38V4.73l-1.32.08s-.63.24-.11.76H17Zm0,0\" transform=\"translate(0 -1.18)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/coal.svg
// module id = y1M8
// module chunks = 264